<maptio-error-page
  [iconName]="'flushed'"
  errorHeadline="This page does not exist!"
  i18n-errorHeadline
></maptio-error-page>
